import Vue from 'vue';
import store from './../../store';
import materialTransformer from './../../transformers/material';

const success = ({ data }, resolve) => {
  const materials = materialTransformer.fetchCollection(data.data);
  store.dispatch('fetchAllMaterials', materials);
  resolve(materials);
};

const failed = () => {};


export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('/production/material')
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/material/all.js